import { SvgIcon } from "@mui/material";

const GoogleBcIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M16 13c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10zm-1-9v7H4V4h11zm6 2h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z"/>
    </SvgIcon>
);

export default GoogleBcIcon;